import SalesService from "../../../services/sales.service";
import {useContext, useState} from "react";
import Utils from "../../../utils/Utils";
import ProductFactory from "../../../models/ProductFactory";
import Toasts from "../../../components/notificacion/Toasts";
import {StateContext} from "../../../components/context/StateProvider";
import Order, {OrderType} from "../../../models/Order";
import StickerService from "../../../services/sticker.service";
import DeliveryService from "../../../services/delivery.service";
import OrderService from "../../../services/order.service";
import NotesService from "../../../services/notes.service";
import {INCIDENCIA_ORIGEN} from "../../../config/constants";


const useSalesOrder = () => {

    const {state, updateState} = useContext(StateContext);

    /**
     * Obtener bultos punteados
     * @param idDelivery
     * @param order
     * @param year
     * @returns {Promise<void>}
     */
    const getDeliveryPackages = async (idDelivery, order, year) => {
        let packages = await DeliveryService.getBultos(idDelivery, order.num, year);
        let registerDate = null;
        packages.map((pack) => {
            if (pack.registrado !== null && (registerDate === null || new Date(pack.registrado) > registerDate)) {
                registerDate = new Date(pack.registrado);
            }
        })
        order.packages = packages;
        order.lastRegisterPackage = registerDate;
    }

    /**
     * Comprobar si tiene productos en nave 2
     * @param order
     * @returns {Promise<void>}
     */
    const checkOrderN2 = async (order, type) => {
        let update = false;

        if (order === null) {
            order = state.order;
            update = true;
        }

        if (order.num !== null) {

            const response = await OrderService.checkOrderN2(order.num, state.year, type);

            if (response?.details?.existen) {

                const orderState = await OrderService.getStateOrderN2(order.num, state.year, type);

                if (orderState.length > 0 && (orderState[0].estado !== order.state || orderState[0].preparado !== order.preparerN2)) {
                    order.stateN2 = (orderState[0].estado === null ? '1' : orderState[0].estado);
                    order.preparerN2 = (orderState[0].preparado === null ? '0' : orderState[0].preparado);
                } else {
                    update = false;
                }

                order.n2 = true;

                if (update) {
                    updateState({order: order});
                }
            }
        }
    }

    /**
     * Obtener personas asignadas al pedido
     * @param order
     * @returns {Promise<void>}
     */
    const getPersonsOrder = async (order, year, type) => {
        const persons = await OrderService.getPersonsOrder(order.num, 'ventas', year, type);
        if (persons.length > 0) {
            order.reviewer = (persons[0].revisado === null ? '0' : persons[0].revisado);
            order.preparer = (persons[0].preparado === null ? '0' : persons[0].preparado);
            order.camera = persons[0].camara;
            order.state = persons[0].estado;
            order.location = persons[0].localizacion;
            order.pedido = persons[0].numero_pedido;
            if (persons[0].imagenes) {
                order.imagenes = persons[0].imagenes;
            }
        }
    }

    /**
     * Obtener información ruta
     * @param order
     * @param year
     * @returns {Promise<void>}
     */
    const getDeliveryOrder = async (order, year) => {
        let infoOrder = Utils.getOrder(order.num);
        let sticker = await StickerService.getStickerMap(infoOrder.serie, infoOrder.order, year);
        if (sticker) {
            let delivery = await DeliveryService.getDelivery(sticker.delivery);
            order.delivery = delivery;
            order.sticker = sticker;
        }
    }

    /**
     * Obtener información incidencias
     * @param order
     * @param year
     * @returns {Promise<void>}
     */
     const getNoteOrder = async (order, year) => {
        let infoOrder = Utils.getOrder(order.num);
        let origen = INCIDENCIA_ORIGEN.SALES;
        if (typeof infoOrder.serie === 'undefined') {
            origen = INCIDENCIA_ORIGEN.PURCHASES;
        }

        let currentNote = await NotesService.getNoteByNum(infoOrder.serie, infoOrder.order, origen);
        if (INCIDENCIA_ORIGEN.SALES && Object.keys(currentNote).length === 0) {
            currentNote = await NotesService.getNoteByNum(infoOrder.serie, infoOrder.order, INCIDENCIA_ORIGEN.STICKER);
        }

        if (currentNote) {
            order.Note = currentNote;
        }
    }


    /**
     * Generar pedido
     * @param lastUpdated
     * @param complete
     * @returns {Promise<void>}
     */
    const createOrder = async (orderNum, lastUpdated, complete, type) => {

        let order = new Order();
        order.num = orderNum;
        order.complete = complete;

        if (lastUpdated) {
            order.setLastUpdated(lastUpdated);
        }

        // Obtener informacion ruta
        await getDeliveryOrder(order, state.year);

        await getNoteOrder(order, state.year);

        // Obtener personas asignadas al pedido
        await getPersonsOrder(order, state.year, type);

        // Comprobar si existe productos en nave 2
        await checkOrderN2(order, type);

        // Obtener bultos punteados
        if (order.delivery?.id) {
            await getDeliveryPackages(order.delivery.id, order, state.year);
        }

        updateState({order: order});
        return order;
    }

    /**
     * Obtener ventas en funcion de la orden
     * @param updateState
     * @param state
     * @returns {Promise<void>}
     */
    const getSales = async (orderNum, nave, type) => {

        try {
            const data = await SalesService.getSales(orderNum, type, state.year, (type === OrderType.Pedido.valueOf()));

            if (data.length > 0) {

                let complete = 0;
                let lastUpdated = null;

                const salesMap = data.map(async (sale, index) => {

                    let stateProduct = 0;
                    let remaining = sale.UNIDADES;
                    let register = 0;
                    let registerDate = undefined;
                    let manual = false;

                    if (!Utils.checkRefProduct(sale.ARTICULO)) {
                        let refArticulo = sale.ARTICULO;

                        if (sale.DUPLICADO) {
                            refArticulo += '-' + sale.LINIA;
                        }

                        const saleRegistry = await SalesService.getSalesProduct(sale.LETRA + '-' + sale.NUMERO, refArticulo, state.year, nave, type);

                        if (saleRegistry.length > 0) {
                            remaining = sale.UNIDADES - saleRegistry[0].unidades;
                            register = saleRegistry[0].unidades;

                            if (remaining === 0) {
                                stateProduct = 1;
                                complete += 1;
                            }

                            registerDate = saleRegistry[0].registrado;
                            manual = saleRegistry[0].manual;

                            if (lastUpdated === null || lastUpdated < new Date(saleRegistry[0].registrado)) {
                                lastUpdated = new Date(saleRegistry[0].registrado);
                            }
                        }
                    } else {
                        sale.UNIDADES = 0;
                        remaining = 0;
                        stateProduct = 1;
                        complete += 1;
                    }

                    let barrasModels = 'BarrasModels';
                    if (state.year !== Utils.getCurrentYear()) {
                        barrasModels = 'BarrasModel' + state.year + 's';
                    }

                    return ProductFactory.productOrder(sale.LETRA + '-' + sale.NUMERO, sale.ARTICULO, sale.INFO_ARTICULO[barrasModels], sale.INFO_ARTICULO.NOMBRE,
                        sale.UNIDADES, sale.INFO_ARTICULO.UBICACION, sale.INFO_ARTICULO.VENSERIE, remaining, stateProduct, register, sale.DUPLICADO, sale.LINIA, registerDate, manual, index);
                });

                const salesMapFull = await Promise.all(salesMap);
                const order = await createOrder(orderNum, lastUpdated, true, type);
                updateState({ products: salesMapFull });
                return order;
            }

            updateState({ loading: false });
        } catch (error) {
            const toasts = Toasts.generateToast(error.response?.data?.message || 'Error al obtener el pedido', 'error');
            updateState({ toasts: [...state.toasts, toasts] });
            updateState({ loading: false });
        }
    };

    return {getSales, checkOrderN2}
}

export default useSalesOrder;